module.exports = __webpack_public_path__ + "static/don16-3a826771ad150e586ea90238c9cdaf89.jpg";